import * as S from "./styles";
import WaybeLogo from "../../assets/images/loading-logo.svg";

export const ModalCarregando = ({ fechamento, titulo }) => {
  return (
    <S.PopupCustomizado fechamento={fechamento}>
      <S.Carregando />

      <S.Logo src={WaybeLogo} />
    </S.PopupCustomizado>
  );
};
